import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material';
import { CustomSvgIconProps, ToggleColorType } from '../../../../types/domain/svg-icons';
import getSVGIconToggleColor from '../../../../utils/svg-icons';

export default function CarIcon(props: CustomSvgIconProps): JSX.Element {
  const defaultColor = useTheme().palette.primary.dark;
  const color = props.htmlColor || defaultColor;
  return (
    <SvgIcon
      {...props}
      htmlColor={color}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      titleAccess="car">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z"
        fill={getSVGIconToggleColor(ToggleColorType.background, props.toggle!!)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.474 8.243c.528-.102 1.405-.119 2.006-.119 1.14 0 3.37.189 4.258.268.435.039.836.25 1.126.596l.583.693c.147.177.265.375.35.589.588 1.479.886 2.3 1.036 2.77.148.467.173.65.164.822v.009c-.012.193-.06.537-.476 1.488-.207.473-.66.78-1.159.78h-.71c-.209.993-1.05 1.735-2.058 1.735-.996 0-1.83-.726-2.05-1.702H9.453c-.22.976-1.054 1.702-2.05 1.702-.996 0-1.83-.726-2.05-1.702H4.126c-.593 0-1.093-.517-1.106-1.137-.016-.243-.048-.935.023-1.67.037-.378.103-.787.222-1.162.115-.363.298-.752.605-1.03.633-.597 1.457-.718 2.17-.823l.073-.01c.378-.056.779-.116 1.207-.223.086-.042.25-.125.468-.235l.237-.12c.51-.257 1.159-.585 1.774-.87.601-.28 1.22-.542 1.653-.644a.542.542 0 01.022-.005zm-6.071 6.723c.278-.881 1.068-1.517 2-1.517.932 0 1.722.636 2 1.517h5.191c.278-.881 1.069-1.517 2-1.517.92 0 1.703.62 1.99 1.484h.778a.128.128 0 00.115-.077c.194-.446.288-.715.333-.873a1.1 1.1 0 00.039-.174 3.504 3.504 0 00-.106-.385c-.136-.428-.42-1.216-1.007-2.69a.928.928 0 00-.152-.255l-.582-.692-.001-.002a.526.526 0 00-.36-.19c-.904-.081-3.08-.264-4.161-.264-.616 0-1.377.02-1.787.097-.31.075-.826.287-1.43.567-.595.277-1.228.597-1.74.855l-.22.111c-.27.137-.483.244-.562.28a.556.556 0 01-.096.035c-.51.131-.98.201-1.372.259m-.87 3.43H4.167a9.737 9.737 0 01.02-1.478c.031-.328.085-.642.168-.902.085-.269.183-.424.267-.5a.696.696 0 00.013-.012c.346-.328.82-.418 1.638-.538m1.13 3.12c-.529 0-.958.451-.958 1.007 0 .555.429 1.005.958 1.005.529 0 .957-.45.957-1.005 0-.556-.428-1.006-.957-1.006zm9.191 0c-.528 0-.957.451-.957 1.007 0 .555.429 1.005.957 1.005.53 0 .958-.45.958-1.005 0-.556-.429-1.006-.958-1.006z"
        fill={getSVGIconToggleColor(ToggleColorType.highlighted, props.toggle!!)}
      />
    </SvgIcon>
  );
}
